const siteConfigRouter = {
  title: '小程序配置',
  type: 'view',
  name: Symbol('log'),
  route: '/site-config',
  filePath: 'view/site-config/site-config.vue',
  inNav: true,
  icon: 'iconfont icon-rizhiguanli',
}

export default siteConfigRouter
